import { theme } from '@orobix/orobix-fe-components'
import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles((t: typeof theme) => ({
  imageNavigation: {
    paddingBottom: '0.6rem',
  },

  image: {
    display: 'inline-block',
    verticalAlign: 'bottom',
  },

  wrapper: {
    display: 'flex',
  },

  imageWrapper: {
    flex: '1',
    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: t.gray03,
  },

  tiles: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translateX(-50%) translateY(-50%)',
    overflow: 'hidden',
  },

  tile: {
    position: 'absolute',
    top: 0,
    left: 0,
  },

  tileContent: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    background: 'rgba(0, 0, 0, 0.2)',
  },

  tileBorder: {
    position: 'absolute',
    top: 0,
    left: 0,
  },

  tileBorderContent: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    top: '-.0631rem',
    right: '-.0631rem',
    bottom: '0',
    left: '0',
    border: '.0631rem solid rgba(255, 255, 255, 0.25)',
    color: 'white',
    fontSize: '0.7rem',
  },

  sliders: {
    width: '14rem',
    marginLeft: '2rem',
  },

  buttons: {
    textAlign: 'right',
  },

  loading: {
    position: 'absolute',
    color: 'white',
  },
}))

export default useStyles
